module.exports = __webpack_public_path__ + "media/dtaai láew pûak tân muay goo maa lá laa gòn doo mĕe bpai gòn pŏm jà doo muay.57b3ea2e.mp3";